import React from 'react'
import { Detailinterface } from '../../../redux/reducers/DetailPageReducer'
import moment from 'moment';
import { formatCurrency } from '../../../common-components/commonFunctions';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

interface SelecteditleTypes {
    DetailData:Detailinterface;
    imageSrc:string;
}

const SelectedTitleDetails:React.FC<SelecteditleTypes> = ({DetailData, imageSrc}) => {
    const DetailDataLoading = useSelector(
        (state: RootState) => state.detailPageReducer.isLoading
    );
    const titleSalesisLoading = useSelector(
        (state: RootState) => state.titleSalesReducer.isLoading
    );
    const navigate = useNavigate();

    return (
        /* Main Container: Controlled with a responsive flex layout */
        <div className="flex flex-col lg:flex-row items-stretch justify-center gap-5 w-full p-1">
            
            {/* 1. LEFT SIDE: Cover Image & Sales Sheet Button */}
            <div className="w-full lg:w-[30%] shrink-0 gap-9 flex flex-col pt-2">
                <div className='bg-white border-2 border-black w-full rounded-xl h-[318px] overflow-hidden flex justify-center items-center'>
                    {imageSrc?.length ? 
                        <img
                            src={imageSrc}
                            className="object-cover ml-3 w-[220px] h-fit rounded-xl"
                            alt="Book Cover"
                        />
                        : ""
                    }
                </div>
                <button
              disabled={!DetailData._id}
              className={` ${DetailDataLoading || !DetailData._id || titleSalesisLoading  ? "bg-[#F87171]":"bg-[#e31c23]"} text-white flex justify-center items-center ${DetailData._id && "hover:bg-red-700"}
                         w-full -mt-8  rounded-md cursor-pointer h-[38px] font-poppins font-semibold border border-none`}
               onClick={() => navigate(`/details/${DetailData._id}`)}
            >
                Sales Sheet
            </button>
            <div className="w-full border border-gray-300 bg-gray-50/50 rounded-xl p-4 shadow-sm flex flex-col gap-3 -my-5 mb-2">
                    <h3 className="text-gray-800 font-bold text-sm tracking-wide uppercase border-b border-gray-200 pb-1.5 flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full bg-[#e31c23]" /> Catalog & Categorization Details
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full -my-2">
            
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">AMAZON SUBTITLE</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData.AMAZON_SUBTITLE?.length > 1 ? DetailData.AMAZON_SUBTITLE : "—"}
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">ASIN</p>
                            <div className="border-[1px] h-[40px] border-gray-300 overflow-x-auto whitespace-nowrap rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.ASIN || "—"}
                            </div>
                        </div>                  
                </div>
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4 w-full border-t border-gray-100 -my-0.5">
          <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mt-2">CATEGORY 1</p>
            <div className="border-[1px] h-[40px] border-gray-300 overflow-x-auto whitespace-nowrap rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                {DetailData?.CATEGORY1 || "—"}
            </div>
        </div> 
        <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1">CATEGORY 2</p>
            <div className="border-[1px] h-[40px] border-gray-300 overflow-x-auto whitespace-nowrap rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                {DetailData?.CATEGORY2 || "—"}
            </div>
        </div>
    </div>

    {/* Grid Row 3: Descriptions Stacked (Full Width) */}
    
    <div className="flex flex-col gap-3 border-t border-gray-100 pt-2 w-full my-0.5">
         <div className="w-full">
                        <p className="text-[#e31c23] font-bold text-xs mb-1">BISAC DESCRIPTION</p>
                        <div className="border-[1px] min-h-[40px] border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                            {DetailData?.BISAC1_DESC || "—"}
                        </div>
                    </div> 
        <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1">BISAC DESCRIPTION 2</p>
            <div className="border-[1px] min-h-[40px] border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                {DetailData?.BISAC2_DESC || "—"}
            </div>
     </div>
        {/* 🟩 NEW FIELD: BISAC DESCRIPTION 3 */}
        <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1">BISAC DESCRIPTION 3</p>
            <div className="border-[1px] min-h-[40px] border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                {DetailData?.BISAC3_DESC || "—"}
            </div>
        </div>
    </div>  
    </div>
            
</div>
            
           
            
         
            

            {/* 2. RIGHT SIDE: 33 Form Metadata Fields (Gets remaining fluid space) */}
            <div className="flex-1 w-full min-w-0 flex flex-col items-center gap-1">
            
{/* 🟩 NEW SIDE-BY-SIDE CONTAINER ROW */}
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 w-full my-2 mt-2 my-auto">

                    {/* 💵 GROUP BOX: Price Details */}
                    <div className="w-full border border-gray-300 bg-gray-50/50 rounded-xl p-4 shadow-sm flex flex-col gap-3">
                        {/* Section Header */}
                        <h3 className="text-gray-800 font-bold text-sm tracking-wide uppercase border-b border-gray-200 pb-1.5 flex items-center gap-2">
                            <span className="w-2 h-2 rounded-full bg-[#e31c23]" /> Price Details
                        </h3>
                        
                        {/* Row 1: Price Fields */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                            <div className="w-full">
                                <p className="text-[#e31c23] font-bold text-xs mb-1"> US PRICE</p>
                                <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                                    {DetailData?.US_PRICE ? `${formatCurrency(DetailData?.US_PRICE, 2)}` : "—"}
                                </div>
                            </div>
                            <div className="w-full">
                                <p className="text-[#e31c23] font-bold text-xs mb-1"> CANADIAN PRICE</p>
                                <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                                    {DetailData?.CANADIAN_PRICE ? `${formatCurrency(DetailData?.CANADIAN_PRICE, 2)}` : "—"}
                                </div>
                            </div>
                            {/* UK PRICE */}
                            <div className="w-full">
                                <p className="text-[#e31c23] font-bold text-xs mb-1"> UK PRICE</p>
                                <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                                    {DetailData?.UK_PRICE ? `${formatCurrency(DetailData?.UK_PRICE, 2)}` : "—"}
                                </div>
                            </div>
                        </div>
                    </div>    

                    {/* 📦 GROUP BOX: Physical Attribute Details */}
                    <div className="w-full border border-gray-300 bg-gray-50/50 rounded-xl p-4 shadow-sm flex flex-col gap-3">
                        {/* Section Header */}
                        <h3 className="text-gray-800 font-bold text-sm tracking-wide uppercase border-b border-gray-200 pb-1.5 flex items-center gap-2">
                            <span className="w-2 h-2 rounded-full bg-[#e31c23]" /> Physical Attribute Details
                        </h3>
                        
                        {/* Row 1: Attributes Grid Layout (Sized for side-by-side) */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 w-full">
                            
                            <div className="w-full">
                                <p className="text-[#e31c23] font-bold text-xs mb-1 whitespace-nowrap">PAGES</p> 
                                <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                                    {DetailData?.PAGES || "—"}
                                </div>
                            </div>
                            <div className="w-full">
                                <p className="text-[#e31c23] font-bold text-xs mb-1">TRIM WIDTH</p> 
                                <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                                    {DetailData?.TRIMWIDTH || "—"}
                                </div>
                            </div>
                            <div className="w-full">
                                <p className="text-[#e31c23] font-bold text-xs mb-1">TRIM LENGTH</p> 
                                <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                                    {DetailData?.TRIMLENGTH || "—"}
                                </div>
                            </div>
                            <div className="w-full">
                                <p className="text-[#e31c23] font-bold text-xs mb-1">CARTON QTY</p> 
                                <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                                    {DetailData?.CARTON_QTY || "—"}
                                </div>
                            </div>
                        </div>
                    </div>

                </div> {/* 🟩 END OF SIDE-BY-SIDE ROW */}
                

                      {/* 2. RIGHT SIDE: 33 Form Metadata Fields (Gets remaining fluid space) */}
            
                
<div className="w-full border border-gray-300 bg-gray-50/50 rounded-xl p-4 shadow-sm flex flex-col gap-2 my-1 my-auto">
    {/* Section Header */}
    <h3 className="text-gray-800 font-bold text-sm tracking-wide uppercase border-b border-gray-200 pb-1.5 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-[#e31c23]" /> Date & Timeline Details
    </h3>
    
    {/* Row 1: Calendar Milestones */}
    <div className="grid grid-cols-1 md:grid-cols-6 gap-4 w-full items-end">
        <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1"> PUB DATE</p>
            <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                {DetailData?.PUB_DATE?.length > 2 ? moment(DetailData?.PUB_DATE).format("MM/DD/YYYY") : "—"}
            </div>
        </div>
        <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1"> RELEASE DATE</p>
            <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                {DetailData.RELEASE_DATE?.length > 1 ? moment(DetailData?.RELEASE_DATE).format("MM/DD/YYYY") : "—"}
            </div>
        </div>
        <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1"> WAREHOUSE DATE</p>
            <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                {DetailData?.WAREHOUSE_DATE?.length > 1 ? moment(DetailData?.WAREHOUSE_DATE).format("MM/DD/YYYY") : "—"}
            </div>
        </div>

         <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1"> PUB MONTH</p>
            <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                {DetailData?.PUBMONTH || "—"}
            </div>
        </div>
        <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1"> LDC</p>
            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                {DetailData?.LDC || "—"}
            </div>
        </div>
        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">PAPERCUT OFF</p>
            <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                {DetailData?.PAPER_CUT_OFF ? DetailData.PAPER_CUT_OFF.split(" ")[0] : "—"}
            </div>
                        </div>
    </div>

</div>

                {/* 🌎 NEW GROUP BOX: Market */}
                <div className="w-full border border-gray-300 bg-gray-50/50 rounded-xl p-4 shadow-sm flex flex-col gap-3 my-2 my-auto">
                    <h3 className="text-gray-800 font-bold text-sm tracking-wide uppercase border-b border-gray-200 pb-1.5 flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full bg-[#e31c23]" /> Market
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 w-full">
                         <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">AUDIENCE</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.AUDIENCE || "—"}
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">GRADE LEVEL</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.GRADE_LEVEL || "—"}
                            </div>
                        </div>
                        <div>
                            <p className="text-[#e31c23] font-bold text-xs mb-1">AGE RANGE</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.AGE_RANGE || "—"}
                            </div>
                        </div>
                                <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1 whitespace-nowrap"> PROMOTIONAL PERIOD</p>
            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                {DetailData?.PROMOTIONAL_PERIOD || "—"}
            </div>
        </div>
                       <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1"> SEASON</p>
            <div className="border border-gray-300 h-[38px] flex items-center justify-center rounded-md w-full p-2 bg-white font-medium text-gray-700 text-sm shadow-sm truncate">
                {DetailData?.SEASON || "—"}
            </div>
        </div>     
                    
    </div>
                    </div>

                {/* 🌎 NEW GROUP BOX: Market, Rights & Distribution */}
                <div className="w-full border border-gray-300 bg-gray-50/50 rounded-xl p-4 shadow-sm flex flex-col gap-3 my-2 my-auto">
                    <h3 className="text-gray-800 font-bold text-sm tracking-wide uppercase border-b border-gray-200 pb-1.5 flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full bg-[#e31c23]" /> Rights & Distribution
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-7 gap-4 w-full">
                         <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">ORIGIN</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.ORIGIN || "—"}
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">TERRITORY</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.TERRITORY || "—"}
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">RIGHTS</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.RIGHTS || "—"}
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">DISCOUNT</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.DISCOUNT || "—"}
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">LICENSED</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.LICENSED || "—"}
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">LICENSOR</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.LICENSOR || "—"}
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">SECOND LICENSOR</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.SECOND_LICENSOR || "—"}
                            </div>
                        </div>
                    </div>
                </div>

                {/* 👥 NEW GROUP BOX: Production & Editorial Team */}
                <div className="w-full border border-gray-300 bg-gray-50/50 rounded-xl p-4 shadow-sm flex flex-col gap-2 my-2 mt-auto">
                    <h3 className="text-gray-800 font-bold text-sm tracking-wide uppercase border-b border-gray-200 pb-1.5 flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full bg-[#e31c23]" /> Production & Editorial Team
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 w-full">
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">PROD MGR</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.PROD_MGR || "—"}
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">EDITOR</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.EDITOR || "—"}
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">MANAGING EDITOR</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.MANAGING_EDITOR || "—"}
                            </div>
                        </div>
                    <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">DESIGNER</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.DESIGNER || "—"}
                            </div>
                        </div>
                    </div>
                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">PUBLICIST</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.PUBLICIST || "—"}
                            </div>
                        </div>
                         <div className="w-full">
                        <p className="text-[#e31c23] font-bold text-xs mb-1">PUBLICITY UPDATE</p>
                        <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                            {DetailData?.PUBLICITY_UPDATE || "—"}
                        </div>
                    </div>
                 </div>
                   
</div>
                
               
            </div>

        </div>
    )
}

export default SelectedTitleDetails;